var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 126,
    viewBox: "0 0 154 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_829)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_47_829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.039 69.3279C153.532 73.2721 152.737 81.6059 148.046 82.8941C143.99 83.9915 144.451 82.1307 144.213 80.9379C144.26 80.6198 144.149 80.1268 144.213 79.9519C144.419 79.4429 147.727 77.2323 150.097 70.9342C151.64 66.8468 152.181 63.2843 150.447 59.0697C150.622 56.3978 150.129 53.0102 150.097 53.71C149.763 58.9584 149.556 57.0499 147.6 55.2209C147.6 54.9028 147.489 50.5928 146.71 51.6584C146.264 50.9427 145.596 50.895 145.453 50.7677C144.737 50.0839 144.197 48.8751 143.402 48.2708C142.749 47.7778 140.491 47.0939 138.312 45.408C128.881 38.1398 128.118 23.9533 114.583 13.6474C102.369 4.3594 95.7209 8.92389 94.6871 8.65352C75.6816 -5.97831 49.7419 1.7034 35.3646 19.0866C28.7325 27.1182 31.7066 27.0069 20.192 37.5514C18.9038 38.7283 14.387 42.0682 13.7667 43.261C10.8403 45.8056 8.45473 49.0342 6.80069 52.5331C5.76692 54.7597 4.9081 57.0499 4.47868 59.4991C3.73119 63.825 3.90614 67.8806 4.65363 72.1747C5.6874 78.1388 7.50048 82.2262 10.904 87.1564C11.4606 87.9517 11.8741 88.715 12.5103 89.4785C9.55211 87.8244 6.8325 85.8523 4.47868 83.419C4.08108 82.5602 1.69546 80.4608 0.550357 75.4828C-1.37405 82.8782 1.25014 89.0809 5.91006 94.7586C8.97956 110.217 20.2556 113.526 34.5535 113.939C35.8258 116.69 38.4182 118.869 41.2491 119.999C44.3981 121.891 54.8154 123.895 62.2108 124.897C62.2426 124.022 62.2744 123.148 62.3062 122.336C62.338 121.557 62.3698 118.631 62.4175 115.18C54.2587 109.74 47.7062 105.764 42.2829 94.6632C41.4718 93.0092 32.7881 26.5616 72.9938 26.5616C74.2025 26.5616 75.2045 26.7684 76.3496 26.832C77.4947 26.7684 78.4967 26.5616 79.7054 26.5616C119.911 26.5616 111.227 93.0092 110.416 94.6632C104.913 105.923 98.2496 109.868 89.8999 115.434C89.9317 118.774 89.9476 121.573 89.9795 122.336C90.0272 123.211 90.059 124.134 90.0908 125.056C109.446 120.348 141.747 109.613 144.372 91.3551C151.56 86.8543 155.918 77.5821 153.024 69.312L153.039 69.3279Z",
    fill: "#582B2D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 125.61,
    fill: "white",
    transform: "translate(0 0.189941)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_47_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 124.116,
    fill: "white",
    transform: "translate(-0.0698242 0.939941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair2);
export default __webpack_public_path__ + "static/media/hair-2.39e981b7417dc9e866062edf19f05ad6.svg";
export { ForwardRef as ReactComponent };